import { Provider } from "react-redux";
import store1 from "./store";
import TransporterDetailsBody from "./TransporterDetailsBody";

const TransporterClientScreen = (props) => {

  return (
    <Provider store={store1}>
      <TransporterDetailsBody property={{ props }} />
    </Provider>
  );
};

export default TransporterClientScreen;
